export const getStatusCount =(value)=>{
  let c=0
  const l=Object.values(value)
  l.forEach(val=>{
    if(val=='ACTIVE')
      c++;
  })
  console.log('value',value,c)
  return c!=0? `Active ${c}`:'Inactive'
}

export const getStatus=(value)=>{
   return value?.includes('Active')?'ACTIVE':'INACTIVE'
}